import { createNamespacedDataProviderStore, extendStore } from './dataprovider';
import ApiClient from '../../client';

// Single-object resource modelled as a one-element items array so we get the helper's
// dedupe lock for free. items[0] is the participant's matching profile (or null on first load).
const store = createNamespacedDataProviderStore((setItems) => {
  return ApiClient.getMatchingProfile()
    .then((response) => {
      setItems([response.data]);
    })
    .catch(() => {
      setItems([]);
    });
});

export default extendStore(store, {
  getters: {
    getProfile: (state) => state.items[0] || null,
    isComplete: (state) => state.items[0]?.isComplete === true
  },
  mutations: {
    setProfile(state, profile) {
      state.items = profile ? [profile] : [];
    }
  },
  actions: {
    async saveProfile({ commit }, payload) {
      commit('setLoading', true);
      commit('setFailed', false);
      try {
        const response = await ApiClient.saveMatchingProfile(payload);
        commit('setProfile', response.data);
        commit('setLoading', false);
        return response.data;
      } catch (err) {
        commit('setFailed', true);
        commit('setLoading', false);
        throw err;
      }
    }
  }
});
